import {useEffect,useState} from 'react';
import {useParams} from 'react-router-dom';
import {api,Job} from '../lib/api';
import {costText} from '../lib/cost';

export function JobDetail(){
  const {id=''}=useParams(),[job,setJob]=useState<Job>(),[error,setError]=useState('');
  useEffect(()=>{
    const load=()=>api.job(id).then(setJob).catch(value=>setError(value.message));
    load();const timer=setInterval(load,2500);return()=>clearInterval(timer);
  },[id]);
  if(error)return <div className="error">{error}</div>;
  if(!job)return <div className="card">در حال بارگذاری…</div>;
  const outputs=Object.keys(job.output_manifest||{});
  const active=['queued','processing','cancelling'].includes(job.status);
  const resumable=['failed','cancelled','waiting_for_quota'].includes(job.status);
  return <>
    <div className="titleRow">
      <div><p className="eyebrow">JOB DETAIL</p><h2>{job.original_filename}</h2></div>
      <div className="jobActions">
        <i className={'badge '+job.status}>{job.status}</i>
        {active&&<button className="dangerButton" onClick={()=>window.confirm('این Job متوقف شود؟')&&api.cancelJob(job.id).then(setJob)}>توقف Job</button>}
        {resumable&&<button className="primary" onClick={()=>api.retry(job.id).then(setJob)}>ادامه پردازش</button>}
      </div>
    </div>
    <div className="jobGrid">
      <section className="card progressCard">
        <div className="bigProgress"><svg viewBox="0 0 36 36"><path d="M18 2.1a15.9 15.9 0 1 1 0 31.8 15.9 15.9 0 1 1 0-31.8"/><path strokeDasharray={`${job.progress},100`} d="M18 2.1a15.9 15.9 0 1 1 0 31.8 15.9 15.9 0 1 1 0-31.8"/></svg><b>{job.progress}٪</b></div>
        <div><h3>{job.status==='completed'?'پردازش کامل شد':job.status==='waiting_for_quota'?'منتظر آزادشدن سهمیه API':job.status==='cancelled'?'پردازش متوقف شد':'در حال پردازش'}</h3><p className="muted">مرحله فعلی: {job.stage}</p>{job.transcription_completed&&<p className="muted">رونویسی ذخیره شده و دوباره اجرا نخواهد شد.</p>}</div>
      </section>
      <section className="card stats"><div><small>مدت</small><b>{job.duration_ms?new Date(job.duration_ms).toISOString().slice(11,19):'—'}</b></div><div><small>Token</small><b>{(job.input_tokens+job.output_tokens).toLocaleString()}</b></div><div><small>هزینه تخمینی</small><b>{costText(job.estimated_cost)}</b></div></section>
    </div>
    {job.error_message&&<div className="error"><b>{job.error_message}</b></div>}
    <section className="card outputs"><h3>فایل‌های خروجی</h3>{outputs.length===0?<p className="muted">پس از تکمیل پردازش، فایل‌ها اینجا نمایش داده می‌شوند.</p>:<div className="outputGrid">{outputs.map(key=><a className="output" key={key} href={api.download(job.id,key)}><span>↓</span><div><b>{key.replace('_',' · ').toUpperCase()}</b><small>دانلود فایل</small></div></a>)}</div>}</section>
  </>;
}